import Product from "components/Productdetail/Product";

import Badges from "views/Badges/Badges";

import Myproducts from "views/Myproducts/Myproducts";

import Dashboard from "views/dashboard/Dashboard.js";

import Usersdetail from "views/Myproducts/Usersdetail";
import Referral from "views/referral/Referral";
// import Addnewproduct from "components/Addnewproduct/Addnewproduct";
import Transactionactivity from "views/transactionactivity/Transactionactivity";
import Editprofile from "components/Editprofile/Editprofile";

var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    layout: "/user",
  },
  {
    path: "/myproducts",
    name: "Users",
    component: Myproducts,
    layout: "/user",
  },
  {
    path: "/usersdetail",
    name: "Users detail",
    component: Usersdetail,
    layout: "/user",
  },

  {
    path: "/ddnewproduct",
    name: "Product Details",
    component: Product,
    layout: "/user",
  },
  {
    path: "/transactionactivity",
    name: "Transaction Activity",
    component: Transactionactivity,
    layout: "/user",
  },

  {
    path: "/purchasednfts",
    name: "Purchased NFTs",
    component: Badges,
    layout: "/user",
  },
  {
    path: "/referral",
    name: "Referral",
    component: Referral,
    layout: "/user",
  },

  {
    path: "/editprofile",
    name: "Edit Profile",
    component: Editprofile,
    layout: "/user",
  },
];
export default routes;
